import { c as _c } from "react/compiler-runtime";
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
interface RemainingTimeResult {
  leftDays: number;
  leftHours: number;
  leftMinutes: number;
  leftSeconds: number;
  leftMilliseconds: number;
  isExpired: boolean;
}
export const useRemainingTime = t0 => {
  const $ = _c(7);
  const {
    endDate
  } = t0;
  const [serverTime, setServerTime] = useState(_temp);
  let t1;
  if ($[0] !== serverTime) {
    t1 = endDate_0 => {
      const totalMilliseconds = endDate_0.diff(serverTime, "millisecond");
      const isExpired = totalMilliseconds <= 0;
      if (isExpired) {
        return {
          leftDays: 0,
          leftHours: 0,
          leftMinutes: 0,
          leftSeconds: 0,
          leftMilliseconds: 0,
          isExpired
        };
      }
      const leftDays = Math.floor(totalMilliseconds / 1000 / 60 / 60 / 24);
      const leftHours = Math.floor(totalMilliseconds / 1000 / 60 / 60) % 24;
      const leftMinutes = Math.floor(totalMilliseconds / 1000 / 60) % 60;
      const leftSeconds = Math.floor(totalMilliseconds / 1000) % 60;
      const leftMilliseconds = totalMilliseconds % 1000;
      return {
        leftDays,
        leftHours,
        leftMinutes,
        leftSeconds,
        leftMilliseconds,
        isExpired
      };
    };
    $[0] = serverTime;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getText = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const interval = setInterval(() => {
        const localTime = Date.now();
        const serverTime_0 = localTime;
        setServerTime(dayjs(serverTime_0));
      }, 10);
      return () => {
        clearInterval(interval);
      };
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== endDate || $[5] !== getText) {
    t4 = getText(endDate);
    $[4] = endDate;
    $[5] = getText;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
function _temp() {
  return dayjs();
}